<template>
<div>
  <div class="row mx-0">
    <router-link class="btn btn-primary" :to="{ name: 'add_business_unit' }" style="line-height: 22px;">
      {{ t('buAddNewBtnText','buAddNewBtnText') }}
    </router-link>
    <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
      <div class="input-group-prepend">
        <div class="input-group-text">
          {{ t('recordsPerPageText','recordsPerPageText') }}
        </div>
      </div>
      <input class="form-control" type="text" v-model="perPage" :placeholder="perPage">
    </div>
    <div class="col-lg-2 col-md-3 col-sm-12 mb-2 mb-md-0">
      <b-input-group>
        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
        <b-button :disabled="!filter" @click="filter = ''">{{ t('clearButtonText','clearButtonText') }}</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
      <span class="btn btn-primary d-flex justify-content-center align-items-center" v-if="getIsNewsnet" @click="resetBusinessUnit()">{{ t('resetBuBtnText','resetBuBtnText') }}</span>
    </div>
  </div>
  <hr>
  <div v-if="businessUnitsRows > 0">
    <b-table id="businessunits-list-table" striped hover bordered :fields="fields" :items="getBusinessUnits" :per-page="perPage" :currentPage="currentPage" :filter="filter" @filtered="onFiltered">
      <template v-slot:cell(short_url)="data">
        <span class="unit-link" @click="switchToUnit(data.item.id)">{{ data.item.short_name }}.nnsend.net</span>
      </template>
      <template v-slot:cell(principal)="data" v-bind:value="data.item.principal">
        <span v-if="data.item.principle">{{ data.item.principle.principle }}</span>
        <span v-else> - </span>
      </template>
      <template v-slot:cell(view_edit)="data">
        <button class="btn btn-warning" type="submit" @click="editUnit(data.item.id)">{{ t('clientConfViewEditBtn','clientConfViewEditBtn') }}</button>
      </template>
      <template v-slot:cell(switch_to)="data">
        <button class="btn btn-success" type="submit" @click="switchToUnit(data.item.id)">{{ t('clientConfSwitchToBtn','clientConfSwitchToBtn') }}</button>
      </template>
      <template v-slot:cell(delete)="data">
        <button class="btn btn-danger" type="submit" @click="deleteUnit(data.item.id, data.item.name)">{{ t('clientConfDeleteBtn','clientConfDeleteBtn') }}</button>
      </template>
    </b-table>
    <div class="row">
      <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
        <p>&nbsp;</p>
        <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="businessUnitsRows" :per-page="perPage" aria-controls="businessunits-list-table" v-if="getBusinessUnits.length > 0"></b-pagination>
      </div>
    </div>
  </div>
  <div v-else>
      <span>{{ t('clientConfNoBusinessUnitsFound', 'clientConfNoBusinessUnitsFound') }}</span>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'BusinessUnitsList',
  data() {
    return {
      fields: [
        {key: 'id', label: '#', thClass: 'hover-pointer brand-color' },
        {key: 'name', label: 'Name', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'short_name', label:'Short Name', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'short_url', name: 'short_url', label: 'Short URL', thClass: 'brand-color'},
        {key: 'website_url', label: 'Website URL', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'principal', label: 'Principal', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'view_edit', name: 'view_edit', label: 'View/Edit', thClass: 'th-centered brand-color text-center', tdClass: 'td-btn'},
        {key: 'switch_to', name: 'switch_to', label: 'Switch To', thClass: 'th-centered brand-color text-center', tdClass: 'td-btn'},
        {key: 'delete', name: 'delete', label: 'Delete', thClass: 'th-centered brand-color text-center', tdClass: 'td-btn'},
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
    }
  },
  methods: {
    resetBusinessUnit() {
      this.$store.dispatch('resetBusinessUnit').then(() => {
        this.$parent.$parent.$parent.$parent.$refs.navbar.update()
        this.$parent.$parent.$parent.$parent.$refs.navbar.applyBackground()
      }, this)
    },
    getClentBusinessUnits() {
      this.$store.dispatch('getClientBusinessUnits')
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    editUnit(id) {
      this.$router.push({ name: 'business_unit', params: { id: id} })
    },
    switchToUnit(id) {
      this.$store.dispatch('switchToBusinessUnit', id).then(() => {
        // force navbar background image to update
        this.$parent.$parent.$parent.$parent.$refs.navbar.update()
        this.$parent.$parent.$parent.$parent.$refs.navbar.applyBackground()
      })
    },
    deleteUnit(id, name) {
      if(confirm("Do you really want to delete " + name + "?")){
        this.$store.dispatch('deleteBusinessUnit', id)
      }
    }
  },
  computed: {
    ...mapGetters(['allTemplateDetails', 'getBusinessUnits', 'getIsNewsnet']),
    businessUnitsRows: {
      get() {
        return this.$store.getters.getBusinessUnits.length
      }
    }
  },
  created() {
    this.getClentBusinessUnits()
    window.addEventListener('resize', () => {
      this.mobile = window.innerWidth <= 700
    })
  }
}
</script>

<style lang="css" scoped>
  .td-btn {
    text-align: center;
    padding: 5px !important;
  }
  .td-btn .btn {
    width: 100%;
  }
  .th-centered {
    text-align: center;
  }
  .unit-link {
    text-decoration: underline;
    color: #047bf8;
    cursor: pointer;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table >>> .hover-pointer:hover {
    cursor: pointer !important;
  }
</style>